<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6><a href="javascript:void(0)" class="text-info" @click="back()"> <i class="fas fa-arrow-left"></i></a> E-News ထည့်ရန်</h6>
					</div>
					<div class="card-body">
						<form v-on:submit.prevent="onSubmit">
							<div class="form-group row">
								<label for="inputName" class="col-sm-2 col-form-label">နာမည် <span class="text-danger">*</span></label>
								<div class="col-sm-10">
									<input type="text" v-model="enewsRequest.name" @blur="validationRule()"
										class="form-control" id="inputName">
									<small class="text-danger">{{validationData.name}}</small>
								</div>
							</div>

							<div class="form-group row">
								<label for="inputupload_date" class="col-sm-2 col-form-label">ရက်စွဲ<span class="text-danger">*</span></label>
								<div class="col-sm-10">
									<input type="date" v-model="enewsRequest.upload_date" @blur="validationRule()"
										class="form-control" id="inputupload_date">
									<small class="text-danger">{{validationData.upload_date}}</small>
								</div>
							</div>

							<div class="form-group row">
								<label for="inputFile" class="col-sm-2 col-form-label">ဖိုင် <span class="text-danger">*</span></label>
								<div class="col-sm-10">
									<input type="file" class="form-control" id="inputFile" @change="readFile">
									<small class="text-danger">{{validationData.file}}</small>
								</div>
							</div>

							<button type="submit" class="btn btn-primary float-save">လုပ်ဆောင်မည်</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'enewsCreate',
		metaInfo: {
            title: "E-News Create",
            titleTemplate: "%s ← SC Dashboard",
        },
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				currentImage: "",
				enewsRequest: {
					name: "",
					upload_date: "",
					file: ""
				},
				validationData: {
					name: "",
					upload_date: "",
					file: ""
				}
			}
		},
		watch: {
			async $route(to, from) {
			},
		},
		computed: {},
		methods: {
			...mapActions({
				enewsStoreAction: 'enewsStoreAction',
			}),
			readFile({ target }) {
				const files = target.files
				const fileReader = new FileReader()
				fileReader.readAsDataURL(files[0])
				fileReader.onload = e => {
					this.enewsRequest.file = e.target.result
					this.validationRule()
				};
			},
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
				let option = this.enewsRequest
				await this.enewsStoreAction({
					...option
				}).then(res => {
					this.back()
					this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
			back() {
				this.$router.replace({ path: 'enews-list', query: {page: 1, reverse: 'desc', sort: 'created_at', name: ''} }).catch(()=>{})
			},
			validationRule() {
				let isValidation = []
				if (this.enewsRequest.name == "") {
					this.validationData.name = "The name field is required."
					isValidation.push(true)
				} else {
					this.validationData.name = ""
					isValidation.push(false)
				}
				if (this.enewsRequest.upload_date == "") {
					this.validationData.upload_date = "The upload_date field is required."
					isValidation.push(true)
				} else {
					this.validationData.upload_date = ""
					isValidation.push(false)
				}
				if (this.enewsRequest.file == "") {
					this.validationData.file = "The file field is required."
					isValidation.push(true)
				} else {
					console.log(this.enewsRequest.file)
					this.validationData.file = ""
					isValidation.push(false)
				}
				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>